export const blackoutInitialValues = {
  from: '',
  to: '',
  from_time: '',
  to_time: '',
};

export enum BlackoutType {
  location = 'location',
  physician = 'physician',
}
